import React from "react";

export default function TeamBioHeader({ data }) {
  const bioData = data;
  let title = bioData?.name;
  let disciplineDesc = bioData?.discipline?.description;
  let event = bioData?.registeredEvents?.at(0)?.event?.description;
  return (
    <div className="page-header2-container">
      <h2 className="h2-container">
        <div className="container d-flex flex-row flex-wrap justify-content-center">
          <div className="h-title">{disciplineDesc}</div>
          {event && <><span className="dash h-title">-</span> <div className="h-title">{event}</div></>}
          <span className="dash h-title">-</span>
          <div className="parent_team_noc">
            <div className="h-title">{title}</div>
          </div>
        </div>
      </h2>
    </div>
  );
}
